import { render, staticRenderFns } from "./HeaderLeagues.vue?vue&type=template&id=f064325c&"
import script from "./HeaderLeagues.vue?vue&type=script&lang=js&"
export * from "./HeaderLeagues.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLeagues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports